import { render } from "./DbConsoleDrawer.vue?vue&type=template&id=3b7dfa3e"
import script from "./DbConsoleDrawer.vue?vue&type=script&lang=js"
export * from "./DbConsoleDrawer.vue?vue&type=script&lang=js"

import "./DbConsoleDrawer.vue?vue&type=style&index=0&id=3b7dfa3e&lang=css"
import "./DbConsoleDrawer.vue?vue&type=style&index=1&id=3b7dfa3e&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__